import styled from 'styled-components'

const CenteredFlexDiv = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

export default CenteredFlexDiv
